import React from "react";

const MenuModulos = ({ vistaActiva, setVistaActiva, setAlumnoSeleccionado, cajeroRol }) => {
  return (
    <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap', backgroundColor: '#fff', padding: '10px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
      <button 
        onClick={() => setVistaActiva('busqueda')}
        style={{ 
          backgroundColor: vistaActiva === 'busqueda' ? '#003b5c' : '#f0f0f0', 
          color: vistaActiva === 'busqueda' ? 'white' : '#333', 
          border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', transition: 'all 0.3s'
        }}
      >
        👨‍🎓 Módulo Alumnos
      </button>

      <button 
        onClick={() => {
          setVistaActiva('externos');
          setAlumnoSeleccionado(null);
        }}
        style={{ 
          backgroundColor: vistaActiva === 'externos' ? '#e67e22' : '#f0f0f0', 
          color: vistaActiva === 'externos' ? 'white' : '#333', 
          border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold', transition: 'all 0.3s'
        }}
      >
        ☕ Módulo Externos
      </button>

      <button
        className={`btn-modulo ${vistaActiva === 'aspirantes' ? 'activo' : ''}`}
        onClick={() => {
          setVistaActiva('aspirantes');
          setAlumnoSeleccionado(null);
        }}
        style={{
          padding: '10px 20px',
          borderRadius: '5px',
          fontWeight: 'bold',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.3s',
          backgroundColor: vistaActiva === 'aspirantes' ? '#003366' : '#f0f0f0',
          color: vistaActiva === 'aspirantes' ? 'white' : '#333'
        }}
      >
        📝 Módulo Aspirantes
      </button>

      <button
        onClick={() => {
          setVistaActiva('exalumnos');
          setAlumnoSeleccionado(null);
        }}
        style={{
          padding: '10px 20px',
          borderRadius: '5px',
          fontWeight: 'bold',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.3s',
          backgroundColor: vistaActiva === 'exalumnos' ? '#6a1b9a' : '#f0f0f0',
          color: vistaActiva === 'exalumnos' ? 'white' : '#333'
        }}
      >
        🎓 Ex-alumnos
      </button>

      <button
        onClick={() => {
          setVistaActiva('reportes');
          setAlumnoSeleccionado(null);
        }}
        style={{
          padding: '10px 20px',
          borderRadius: '5px',
          fontWeight: 'bold',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.3s',
          backgroundColor: vistaActiva === 'reportes' ? '#2e7d32' : '#f0f0f0',
          color: vistaActiva === 'reportes' ? 'white' : '#333'
        }}
      >
        📊 Reportes
      </button>

      {String(cajeroRol) === "1" && (
        <button
          onClick={() => {
            setVistaActiva('usuarios');
            setAlumnoSeleccionado(null);
          }}
          style={{
            padding: '10px 20px',
            borderRadius: '5px',
            fontWeight: 'bold',
            cursor: 'pointer',
            border: 'none',
            transition: 'all 0.3s',
            backgroundColor: vistaActiva === 'usuarios' ? '#5d4037' : '#f0f0f0',
            color: vistaActiva === 'usuarios' ? 'white' : '#333'
          }}
        >
          👥 Usuarios
        </button>
      )}
    </div>
  );
};

export default MenuModulos;